/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Editor_Table_Columns_HeadingInputs */



/**
* | output |
* | --- |
* | "Table columns" |
*
* @param {Editor_Table_Columns_HeadingInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const editor_table_columns_heading = /** @type {((inputs?: Editor_Table_Columns_HeadingInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Editor_Table_Columns_HeadingInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Colonnes du tableau")
	if (locale === "de") return /** @type {LocalizedString} */ ("Tabellenspalten")
	if (locale === "it") return /** @type {LocalizedString} */ ("Colonne della tabella")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Столбцы таблицы")
	if (locale === "es") return /** @type {LocalizedString} */ ("Columnas de la tabla")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("表格列")
	if (locale === "ja") return /** @type {LocalizedString} */ ("テーブルの列")
	if (locale === "hi") return /** @type {LocalizedString} */ ("तालिका स्तंभ")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Colunas da tabela")
	return /** @type {LocalizedString} */ ("Table columns")
});